module.exports = __webpack_public_path__ + "img/illu-liver.6afab120.svg";